import useProfileCommonStore from '../use-profile-common-store';
import _get from 'lodash/get';

import { useProfileInvestmentByType } from '../../../hooks/api';

const useInvestmentByType = () => {
  const { apiConfigBase, commonState } = useProfileCommonStore();
  const investmentByType = useProfileInvestmentByType(apiConfigBase);
  const ticker = _get(commonState, 'xref.data.symbol', '');

  return {
    asOfDate: _get(investmentByType, 'data.asOfDate', ''),
    investmentByType: _get(investmentByType, 'data.items', []),
    ticker
  };
};

export default useInvestmentByType;
